import { Helmet } from "react-helmet"
import { useEffect } from "react"
import useViewportWidth from "../../hooks/useViewportWidth"

export default function WineList({ setIsMenuOpen, setShowReservBtn }) {
    const viewportWidth = useViewportWidth()

    useEffect(() => {
        if (viewportWidth < 990) {
            setIsMenuOpen(false)
        }
        setShowReservBtn(true)
    }, [])
    const url = "https://drive.google.com/file/d/1mg9vQmWWGjd1PSNCvcJCzxY8NGLQ7oNw/preview"
    return (
        <div>
            <Helmet>
                <title>Borlap / Winlelist</title>
                <meta name="desription" content="Megtkeinheti Borlapunkat / You can browse our Winlelist" />
            </Helmet>
            <iframe src={url} title="winelist" allow="autoplay"></iframe>
        </div>
    )
}